import React from "react";

//import NavBar from '../component/appBarcomponent/Navbar';
import Cartbody from "./Cartbody";

import {
  CssBaseline,
  Stack,
} from "@mui/material";

import Navbar from "../../redesign/components/Navbar";
import Footer from "../../redesign/components/Footer";

function Cartpage(){
    return(
        <>
        <CssBaseline />
        <Navbar />
        <Cartbody />
        <Footer />
        </>
    )
}

export default Cartpage